import React from 'react';

const overlay = ({ className = 'dp-overlay', ...rest }) => {
  return <div className={className} {...rest} />;
};

export default overlay;
